'use client'

import { createContext, useContext, ReactNode } from 'react'
import { useSSE, UseSSEOptions } from '../hooks/use-sse'
import { SSEMessageHandler } from '../hooks/use-sse'

interface SSEContextValue {
  isConnected: boolean
  subscribe: (messageType: string, handler: SSEMessageHandler) => void
  unsubscribe: (messageType: string, handler: SSEMessageHandler) => void
  connect: () => void
  disconnect: () => void
}

const SSEContext = createContext<SSEContextValue | null>(null)

interface SSEProviderProps {
  children: ReactNode
  options?: UseSSEOptions
}

export function SSEContextProvider({ children, options }: SSEProviderProps) {
  const sseInstance = useSSE({
    autoConnect: true,
    ...options
  })

  return <SSEContext.Provider value={sseInstance}>{children}</SSEContext.Provider>
}

export function useSSEContext(): SSEContextValue {
  const context = useContext(SSEContext)
  if (!context) {
    throw new Error('useSSEContext must be used within SSEContextProvider')
  }
  return context
}
